import { Scene } from "phaser";

import { GButton } from "../gameobjects/GButton";

import { unixToDate, getDrawByID, formatUnixTimestamp,datetimeToUnixTimestamp, stringToNumberArray , formatNumberWithCommas} from '../utils';
import { WinningNumbersDesktop } from "../gameobjects/WinningNumbersDesktop";

// The HUD scene is the scene that shows the points and the remaining time.
const COLOR_BLUE = "#00FFF0";
const COLOR_DIMM = "#757B8C";
const COLOR_DARK = 0x212121;
export class ResultsSceneDesktop extends Scene {
    
    constructor() {
        super("ResultsSceneDesktop");

    }

    init(data) {
        //this.cameras.main.fadeIn(500, 0, 0, 0);
        //console.log('init', data);
        const { draw_date_id } = data;
        this.draw_date_id = draw_date_id;
        if(draw_date_id == undefined) {
            this.draw_date_id = this.registry.get('latest_draw');
            
        }


    }

    async create() {

        //console.log("this.draw_date_id", this.draw_date_id);
        const response = await getDrawByID(this.registry.get('gamecode'), this.draw_date_id)

        if(response.status !== 200){

            let message = response.data.error || "Network error"
            this.scene.start("ErrorScene", {message:message})
            return
        }

        this.drawInfo = response.data;

        const containerY = 62;
        const HeaderY = 62
        this.numberGrid = [];

        


        // Create the title
        this.title = this.add.text(this.scale.width/2, HeaderY  , `RESULTS`,  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(0.5,0);
        this.title.setFontStyle('700')

        // Create the back button
        const ButtonBack = new GButton(this,this.scale.width/2-380, HeaderY + 16, {
            texturePack: "pack", 
            text: {
                value: 'BACK',
                style:  { fontFamily: 'Oswald', fontSize: 20, color: '#ffffff' }
            },
            icon: {
                image: 'arrow back_ios.png',
                scale: 0.4,
                align: 'left',
                x: -30
            },
            onClick: () => {
                this.scene.start("MenuScene");
             }
        });



        // Generate the blur background
        this.createBlurBackground(containerY);






        this.currentDrawInfo = this.registry.get('currentDraw');


        this.TicketsHeader = this.add.nineslice(this.scale.width/2,  HeaderY + this.title.height + 32, 'pack', 'header-main.png', this.scale.width*0.8, 52, 32, 32,16,16);
        //this.TicketsHeader.setScale(0.75);
    
        const game_over_timeout = datetimeToUnixTimestamp(this.drawInfo.draw_date)

        this.DrawDate = unixToDate( game_over_timeout );
    
        this.DrawDate = formatUnixTimestamp( this.registry.get('drawdate'));

        //console.log("this.DrawDate", this.registry.get('drawdate'))
        //console.log("this.drawInfo.draw_date", formatUnixTimestamp(datetimeToUnixTimestamp(this.drawInfo.draw_date)))

        this.drawDateDate = this.add.text(this.scale.width/2,  containerY +74, formatUnixTimestamp(datetimeToUnixTimestamp(this.drawInfo.draw_date)) ,  { fontFamily: 'Oswald', fontSize: 14, color: '#ffffff' }).setOrigin(0.5,0);
        this.drawDateDate.setFontStyle('700')


        this.drawNumberText = this.add.text(this.scale.width/2,  containerY+50 , `DRAW NO. ${this.drawInfo.draw_date_id}` ,  { fontFamily: 'Oswald', fontSize: 16, color: '#ffffff' }).setOrigin(0.5,0);
        this.drawNumberText.setFontStyle('700')



        this.noTicketsText = this.add.text(this.scale.width/2,   containerY + 216 +52/2 + 210/2, `NO TICKETS YET...` ,  { fontFamily: 'Oswald', fontSize: 16, color: '#ffffff' }).setOrigin(0.5);
        this.noTicketsText.setFontStyle('700')

        this.noTicketsText.setVisible(false);

        const containerHeight =  460*2

        this.boxHight = this.scale.height/2;

        this.WinningNumbersContainer = this.add.container(this.scale.width/2, this.TicketsHeader.y +this.TicketsHeader.height -8)

        if(this.drawInfo !== null && this.drawInfo.winning_numbers !== undefined && this.drawInfo.winning_numbers !== ""){
            
            this.createGridWinning(stringToNumberArray(this.drawInfo.winning_numbers))
        }

        const ticketNumberText = this.add.text(0,0, `WINNING NUMBERS`, {
            fontFamily: 'Oswald', 
            fontSize: '32px',
            color: '#fff',
        }).setOrigin(0.5); // Set origin to top-left;

        ticketNumberText.setFontStyle('700')
        ticketNumberText.setScale(0.5)



        // Tabs
        this.MyResultsText = this.add.text(this.scale.width/2-260, this.scale.height/2 -16, ` My Results`,  { fontFamily: 'Oswald', fontSize: 40, color: COLOR_BLUE }).setOrigin(0,0.5).setInteractive();
        this.MyResultsText.setFontStyle('700')
        this.MyResultsText.setScale(0.5)


        this.WinningSharesText = this.add.text(this.scale.width/2+260, this.scale.height/2 - 16, ` Winning Shares`,  { fontFamily: 'Oswald', fontSize: 40, color: COLOR_DIMM }).setOrigin(1,0.5).setInteractive();
        this.WinningSharesText.setFontStyle('700')
        this.WinningSharesText.setScale(0.5)
        // Add the text object to this container
        this.WinningNumbersContainer.add(ticketNumberText);


        

    
        this.TicketsHeader = this.add.nineslice(this.scale.width/2,  this.scale.height/2+30, 'pack', 'header-main.png', this.scale.width*0.8, 52, 32, 32);
        //this.TicketsHeader.setScale(0.75);


        this.totalPrizeAmountText = this.add.text(this.scale.width*0.9- 30,  this.scale.height/2 + 30, `` ,  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(1, 0.5);
        this.totalPrizeAmountText.setFontStyle('700')
        this.totalPrizeAmountText.setScale(0.5)

        this.totalPrizesText = this.add.text( this.totalPrizeAmountText.x - this.totalPrizeAmountText.width - 32,  this.scale.height/2 + 30, `TOTAL PRIZES:` ,  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(1, 0.5);
        this.totalPrizesText.setFontStyle('700')
        this.totalPrizesText.setAlpha(0.7)
        this.totalPrizesText.setScale(0.5)

        this.totalTicketsText = this.add.text(this.scale.width*0.1 + 30,  this.scale.height/2 + 30, `TOTAL TICKETS:` ,  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(0, 0.5);
        this.totalTicketsText.setFontStyle('700')
        this.totalTicketsText.setAlpha(0.7)
        this.totalTicketsText.setScale(0.5)

        this.totalTicketsAmountText = this.add.text(this.totalTicketsText.x + this.totalTicketsText.width/2 + 10,  this.scale.height/2 + 30, this.drawInfo.tickets.length ,  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(0, 0.5);
        this.totalTicketsAmountText.setFontStyle('700')
        this.totalTicketsAmountText.setScale(0.5)


        this.panel = this.rexUI.add.scrollablePanel({
            x: this.scale.width/2, y: this.scale.height/2+50,
            height:  230,
            width:  this.scale.width*0.8,
            originY: 0,

            scrollMode: 0,
            mouseWheelScroller: {
                focus: true,
                speed: 0.1
            },
            // background: this.rexUI.add.roundRectangle({
            //     color: COLOR_DARK,
            //     // strokeColor:"#FFFFF",
            //     radius: { tl: 0, tr: 0, bl: 32, br: 32 }
            // }),
            panel: {
                child: this.CreatePanel(this),//this.CreatePanel(this)
                //mask: { padding: 30, },
            },
            space: { left: 0, right: 0, top: 20, bottom: 20, panel: 10}
        })
        .layout()

        
        
        this.updateTicketList();
        

         // Create container
        const SHareContainer = this.add.container(this.scale.width / 2, this.scale.height / 2 + 30);

          // Define the size of the container
        const containerWidth = 300;

        // Add a NineSlice background to the container
        const SharesHeaaders = this.add.nineslice(
            0, 0,              // x, y position within the container
            'pack', 'header-main.png', this.scale.width*0.8, 52, 32, 32
        );

        SharesHeaaders.setOrigin(0.5); // Center the background inside the container

        // Add a text object at the top of the container
        const titleText = this.add.text((this.scale.width / 2) *-1 +this.scale.width*0.1+32, 0, 'WINNING SHARES', { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(0, 0.5);
        titleText.setFontStyle('700')
        titleText.setScale(0.5)
        // Add background and text to the container

        SHareContainer.add([SharesHeaaders]);


        this.sortedArray = [];
        if(this.drawInfo.winning_shares !== null  && this.drawInfo.winning_shares !== undefined){
            this.sortedArray = Object.keys(this.drawInfo.winning_shares)
                .sort((a, b) => b - a) // Sort keys in descending order
                .map((key, index) => {
                    const item = this.drawInfo.winning_shares[key];
                    return {
                        group: `Group ${index + 1}`, // Group number starts from 1
                        share_amount: item.shares * item.share_value, // shares * share_value
                        winners: item.shares
                    };
                });

            //console.log(this.sortedArray);

        }

       
        
        const gridTable = this.rexUI.add.scrollablePanel({
            x: this.scale.width/2, 
            y: SHareContainer.getBounds().y +52,
            width:  this.scale.width*0.8,
            height: 230,
            originY: 0,

            scrollMode: 0,
            // background: this.rexUI.add.roundRectangle({
            //     color: COLOR_DARK,
            //     // strokeColor:"#FFFFF",
            //     radius: { tl: 0, tr: 0, bl: 32, br: 32 }
            // }),
            panel: {
                child: this.CreatePanelShares(this),
                //mask: { padding: 30, },
            },
            space: { left: 40, right: 20, top: 16, bottom: 20, panel: 10}
        })
        .layout()
        
        gridTable.setVisible(false)

        const panelContent = gridTable.getElement('panel');
        let Tcontainer = this.createTableContainer(this.sortedArray)
        panelContent.add(Tcontainer);

        gridTable.layout();

       
        SHareContainer.add([titleText]);
        
        SHareContainer.setVisible(false)

        this.MyResultsText.on('pointerup', () => {
            this.MyResultsText.setColor(COLOR_BLUE);
            this.WinningSharesText.setColor(COLOR_DIMM)
            this.panel.setVisible(true)
            this.TicketsHeader.setVisible(true)
            this.totalPrizesText.setVisible(true)
            this.totalPrizeAmountText.setVisible(true)
            SHareContainer.setVisible(false)
            gridTable.setVisible(false)
        });

        this.WinningSharesText.on('pointerup', () => {
            this.MyResultsText.setColor(COLOR_DIMM);
            this.WinningSharesText.setColor(COLOR_BLUE)
            this.panel.setVisible(false)
            this.TicketsHeader.setVisible(false)
            this.totalPrizesText.setVisible(false)
            this.totalPrizeAmountText.setVisible(false)
            SHareContainer.setVisible(true)
            gridTable.setVisible(true)
        });

        if(this.drawInfo.tickets.length == 0){
            this.MyResultsText.setVisible(false)
            this.WinningSharesText.setVisible(false)
            SHareContainer.setVisible(true)
            gridTable.setVisible(true)
        }
        

    }


    createBlurBackground(containerY){
      // Load and blur the background image
      this.backgroundImage = this.add.image(0, 0, 'lotto-bg');
      this.backgroundImage.setOrigin(0, 0);
      this.backgroundImage.setScale(
          this.scale.width / this.backgroundImage.width,
          this.scale.height / this.backgroundImage.height
      );

      // Create the mask graphics
      this.boxGraphics = this.add.graphics();
      this.boxGraphics.fillStyle(0xaaaaaa, 0.1);
      this.boxGraphics.fillRoundedRect(
          this.scale.width/2- this.scale.width*0.8/2, containerY + 78,this.scale.width*0.8,130, { tl: 0, tr: 0, bl: 32, br: 32 }
      );

      this.boxGraphics.fillRoundedRect(
          this.scale.width/2- this.scale.width*0.8/2,  containerY + 268 +52/2,this.scale.width*0.8, 230, { tl: 0, tr: 0, bl: 32, br: 32 }
      );

      // Apply the mask to the background image
      this.backgroundImage.setMask(new Phaser.Display.Masks.GeometryMask(this, this.boxGraphics));

      // Add blur effect
      this.backgroundImage.preFX.addBlur(1, 2, 2, 2, 0xffffff, 4);
    }


    CreatePanel(scene) {
        var rowCount = 1 
        if(this.drawInfo.tickets.length > 0){
            rowCount = Math.ceil(this.drawInfo.tickets.length/4)
        }

        this.gridSizer = this.rexUI.add.gridSizer(0,0,{
            orientation: 'vertical',
            width: this.scale.width*0.8,
            space: { 
                left: 16,
                right: 0,
                top: 0, 
                bottom: 0, 
                column: 224, 
                row: 114
            },
            // background: this.rexUI.add.roundRectangle({
            //     color: COLOR_DARK,
            //     // strokeColor:"#FFFFF",
            //     radius: { tl: 0, tr: 0, bl: 32, br: 32 }
            // }),
            column: 4,  // col: 0
            //columnProportions: [1, 1, 1, 1], // make both columns 50%
            row: rowCount+1,
        })

        this.gridSizer.setOrigin(0,0.5)
        console.log(" this.gridSizer",  this.gridSizer)

        return this.gridSizer;
    }


    CreatePanelShares(scene) {
        var panel = scene.rexUI.add.sizer({
            orientation: 'y',
            space: { top: 0, bottom: 0 }
        })
    
        return panel;
    }



    createCellContainer(cell, cellContainer) {
        const scene = cell.scene;
        const item = cell.item;
        const index = cell.index;

        if (cellContainer === null) {
            cellContainer = scene.rexUI.add.sizer({
                orientation: 'horizontal',
                space: { left: 5, right: 5 }
            });

            const col1Text = scene.add.text(0, 0, '', { fontSize: '16px', color: '#FFFFFF' });
            const col2Text = scene.add.text(0, 0, '', { fontSize: '16px', color: '#FFFFFF' });
            const col3Text = scene.add.text(0, 0, '', { fontSize: '16px', color: '#FFFFFF' });

            cellContainer
                .add(col1Text, { proportion: 1, align: 'left' })
                .add(col2Text, { proportion: 1, align: 'left' })
                .add(col3Text, { proportion: 1, align: 'left' });

            cellContainer.setData('colTexts', [col1Text, col2Text, col3Text]);
        }

        const colTexts = cellContainer.getData('colTexts');
        colTexts[0].setText(item.col1);
        colTexts[1].setText(item.col2);
        colTexts[2].setText(item.col3);

        // Zebra striping
        const bgColor = (index % 2 === 0) ? 0xf0f0f0 : 0xffffff;

        // Remove previous background if exists
        const prevBg = cellContainer.getData('bg');
        if (prevBg) {
            prevBg.destroy();
        }

        // Add background rectangle
        const bg = scene.rexUI.add.roundRectangle(0, 0, 20, 20, 0, bgColor);
        cellContainer.addBackground(bg);
        cellContainer.setData('bg', bg);

        return cellContainer;
    }


    // CreatePanel(scene) {
    //     var panel = scene.rexUI.add.sizer({
    //         orientation: 'y',
    //         space: { top: 0, bottom: 20 }
    //     })
    
    //     return panel;
    // }


       // Method to create and display the grid of numbers as text objects
       createGridWinning(numbersArray) {
        const columns = 6;       // Number of columns
        const textSpacingX = (30)*2 ; // Horizontal space between text objects
        const textSpacingY = 20; // Vertical space between text objects

        for (let i = 0; i < numbersArray.length; i++) {
            const number = numbersArray[i];

            // Calculate the x and y position for each text object
            const x = (i % columns) * textSpacingX - 150;
            const y = Math.floor(i / columns) * textSpacingY + 44;

            // Create the text object for the current number
            
            const numberCircle = this.add.sprite(x, y, 'pack' ,'Lotto Number - Winner - Default.png');
            numberCircle.setScale(0.5)
            this.WinningNumbersContainer.add(numberCircle)
            
            const numberText = this.add.text(x, y, number.toString(), {
                fontFamily: 'Montserrat',
                fontSize: '30px',
                color: '#fff',
            });
            numberText.setOrigin(0.5)
            numberText.setFontStyle('700')
            numberText.setScale(0.5)

            this.WinningNumbersContainer.add(numberText)
            
        }
    }


    updateTicketList(){
        var sum = 0
        
        try {
            this.panel.getElement('panel').removeAll(true);    
        } catch (error) {
            console.log(error)
        }
        
        for (let index = 0; index < this.drawInfo.tickets.length; index++) {
            const element = this.drawInfo.tickets[index];
           sum += +element.prize_amount
           
           var lastBoxY = 360;
           this.currentBound = 20
       
           //92, lastBoxY
           this.numberGrid[index] = new WinningNumbersDesktop(this, 0 , 0, {winningNumbers: this.drawInfo.winning_numbers, numbersArray: this.drawInfo.tickets[index], ticketNumber: index });
           //this.ticketContainer.add(this.numberGrid[index]);
           //if(index > 0){
            const bounds = this.numberGrid[index].getBounds()
            
            lastBoxY = bounds.height + bounds.y + 50
            
            this.currentBound = bounds.height;
            //}

            const column = index % 4;
            const row = Math.floor(index / 4);
            console.log("column", column)
            console.log("row", row)
 
            this.gridSizer.add(
                 this.numberGrid[index],
                 column,
                 row,
                 'center',
                 0,
                 true
             );

        //    this.panel
        //    .getElement('panel')
        //    .add(
        //         this.numberGrid[index],
        //         {
        //             proportion: 0,
        //             align: 'left',
        //             padding: {left: 44, right: 0, top: 0 , bottom: this.currentBound + 36},
        //             expand: false,
        //             fitRatio: 0,  
        //             offsetX: 0,
        //             //offsetY: lastBoxY,
        //         }
        //    );
        //    this.panel
        //    .getElement('panel')
           
        }

     
        this.gridSizer.layout();

        //this.panel.setMinSize(this.panel.width, 346*2).layout();
        this.panel.layout()
        //console.log("full sum:", sum)
        this.totalPrizeAmountText.setText(`$${formatNumberWithCommas(sum)}`);
        
        this.totalPrizesText.setX( this.totalPrizeAmountText.x - this.totalPrizeAmountText.width/2 -12 )
        

    }


    // Create a Container for "Table" Type
    createTableContainer(item) {

        const tableContainer = this.rexUI.add.gridSizer({
            column: 3,
            width: 400*2,
            row: item.length + 1, // +1 for headers
            space: { column: 90, row: 20 },
            rowProportions: 1,
            columnProportions: [1, 1, 1], // make both columns 50%

            //background: roundedRect,
            //rowProportions: 1,
        });


        // CREATE HEADER

        const Header1 = this.add.text(0, 0, `PRIZE GROUP`, {
            fontSize: '24px',
            fontFamily: 'Montserrat',
            color: '#F9F9FF',
            align: 'center',
            lineSpacing: 10,
            wordWrap: { width:  186*2, useAdvancedWrap: true }
        });
        Header1.setOrigin(0.5)
        Header1.setFontStyle('700')
        Header1.setScale(0.5)

        tableContainer.add(Header1, 0, 0, 'center', 0, false);


        const Header2 = this.add.text(0, 0, `SHARE AMOUNT`, {
            fontSize: '24px',
            fontFamily: 'Montserrat',
            color: '#F9F9FF',
            align: 'center',
            lineSpacing: 10,
            wordWrap: { width:  186*2, useAdvancedWrap: true }
        });
        Header2.setOrigin(0.5)
        Header2.setFontStyle('700')
        Header2.setScale(0.5)

        tableContainer.add(Header2, 1, 0, 'center', 0, false);

        const Header3 = this.add.text(0, 0, `NO. OF WINNING SHARES`, {
            fontSize: '24px',
            fontFamily: 'Montserrat',
            color: '#F9F9FF',
            align: 'center',
            lineSpacing: 10,
            wordWrap: { width:  186*2, useAdvancedWrap: true }
        });
        Header3.setOrigin(0.5)
        Header3.setFontStyle('700')
        Header3.setScale(0.5)
        
        tableContainer.add(Header3, 2, 0, 'center', 0, false);



        // Add Rows
        item.forEach((row, rowIndex) => {
            //console.log("row", row)
            const isEvenRow = rowIndex % 2 === 0; // Determine if the row is even

            // const rowBackground = this.add.graphics();
            // rowBackground
            //     .fillStyle(isEvenRow ? 0xf0f0f0 : 0xdcdcdc) // Alternate row color
            //     .fillRect(0, 0, 560, 40); // Adjust the row size as needed

            // // // Add the background to the table
            // tableContainer.addBackground(rowBackground)// background =this.rexUI.add.roundRectangle(0, 0, 2, 2, 10, "0x0000ff");

            const bgColor = (rowIndex % 2 === 0) ? 0xf0f0f0 : 0xe0e0e0;
            const bgRect = this.add.rectangle(0, 0, 2, 2, bgColor).setOrigin(0);
          
            // Add background covering both columns (colspan: 2)
            //tableContainer.addBackground(bgRect, rowIndex, 0, 2, 1);

            const text = this.add.text(0, 0, row.group, {
                fontSize: '24px',
                fontFamily: 'Montserrat',
                color: '#F9F9FF',
                align: 'center',
                lineSpacing: 10,
                wordWrap: { width:  186*2, useAdvancedWrap: true }
            });
            text.setOrigin(0.5)
            text.setScale(0.5)

            tableContainer.add(text, 0, rowIndex + 1, 'center', 0, false);

            
            let shareAmountValue = "-"
            if(row.share_amount > 0){
                shareAmountValue = `$` +formatNumberWithCommas(row.share_amount);
            }

            const share_amount = this.add.text(0, 0, shareAmountValue , {
                fontSize: '24px',
                fontFamily: 'Montserrat',
                color: '#F9F9FF',
                align: 'center',
                lineSpacing: 10,
                wordWrap: { width:  186*2, useAdvancedWrap: true }
            });
            share_amount.setOrigin(0.5)
            share_amount.setScale(0.5)
            tableContainer.add(share_amount, 1, rowIndex + 1, 'center', 0, false);

            let winnerCount = "-"
            if(row.winners > 0){
                winnerCount =  parseFloat(row.winners).toLocaleString( 'en-US',{ minimumFractionDigits: 0, maximumFractionDigits: 0 });
            }

            const winners = this.add.text(0, 0, winnerCount, {
                fontSize: '24px',
                fontFamily: 'Montserrat',
                color: '#F9F9FF',
                align: 'center',
                lineSpacing: 10,
                wordWrap: { width:  186*2, useAdvancedWrap: true }
            });
            winners.setOrigin(0.5)
            winners.setScale(0.5)   
            tableContainer.add(winners, 2, rowIndex + 1, 'center', 0, false);

            
            
        });

        return tableContainer;
    }

}